import { Box, styled } from '@mui/material';

export const StyledModalContainer = styled(Box)(({ theme }) => ({
  top: '50%',
  left: '50%',
  width: '560px',
  outline: 'none',
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  transform: 'translate(-50%, -50%)',
  gap: theme.spacing(3),
  padding: theme.spacing(8),
  borderRadius: theme.spacing(6),
  backgroundColor: theme.palette.background.default,
}));
